module.exports = __webpack_public_path__ + "img/Navy-06.c30c0d74.jpg";